import Expandable from './expandable.js';

document.addEventListener( 'DOMContentLoaded', function() {
	const advancedSearchContainer = document.querySelector( '.c-site-advanced-search-form' );
	if ( ! advancedSearchContainer ) {
		return;
	}

	new Expandable( advancedSearchContainer );
} );
